import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/home/Marquee";
import { Manifesto } from "../components/home/Manifesto";
import { Categories } from "../components/home/Categories";
import { B2B } from "../components/home/B2B";
import { ServicesGrid } from "../components/home/ServicesGrid";
import { Portfolio } from "../components/home/Portfolio";
import { Differentials } from "../components/home/Differentials";
import { Process } from "../components/home/Process";
import { SocialProof } from "../components/home/SocialProof";
import { Faq } from "../components/home/Faq";
import { FinalCta } from "../components/home/FinalCta";
import { scrollToHash } from "../lib/scroll";
import { track } from "../lib/analytics";

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        track("page_view", { page: "home" });
        if (location.state?.scrollTo) {
            const target = location.state.scrollTo;
            const t = setTimeout(() => scrollToHash(target), 350);
            return () => clearTimeout(t);
        }
    }, [location.state]);

    return (
        <main>
            <Seo
                title="IMPRIMA AKI — Gráfica e Comunicação Visual em Campinas | Placas, Banners, Camisetas e Adesivos"
                description="Gráfica e comunicação visual em Campinas – SP. Cartões de visita, panfletos, placas, banners, adesivos, camisetas personalizadas, uniformes, fachadas e envelopamento automotivo. Orçamento pelo WhatsApp (19) 99494-5505."
            />
            <Hero />
            <Marquee />
            <Manifesto />
            <Categories />
            <B2B />
            <ServicesGrid />
            <Portfolio />
            <Differentials />
            <Process />
            <SocialProof />
            <Faq />
            <FinalCta />
        </main>
    );
}
